import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Input, Space, Spin, message } from "antd";
import {
  createSprTemplateNazn,
  fetchSprTemplateNaznList,
  saveSprTemplateNazn
} from "./spr-template-nazn-api";
import { normalizeZag } from "./spr-template-nazn-utils";

const LABEL_WIDTH = 120;

const formItemLayout = {
  labelCol: { flex: `0 0 ${LABEL_WIDTH}px` },
  wrapperCol: { flex: "1 1 auto" },
  labelAlign: "right"
};

/**
 * Вкладка «Основная» — наименование шаблона (Delphi TFrmESprShbNaznZag).
 */
const SprTemplateNaznMain = ({ idShb, isNew, open, canEdit, onSaved, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");

    if (isNew) {
      form.resetFields();
      form.setFieldsValue({ name: "" });
      return;
    }

    if (idShb == null) return;

    let cancelled = false;
    setLoading(true);
    fetchSprTemplateNaznList()
      .then((data) => {
        if (cancelled) return;
        const rows = Array.isArray(data) ? data.map(normalizeZag) : [];
        const row = rows.find((r) => r.idShb === idShb);
        if (!row) {
          setError("Шаблон не найден");
          return;
        }
        form.setFieldsValue({ name: row.name ?? "" });
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Не удалось загрузить");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, isNew, idShb, form]);

  const onFinish = async (values) => {
    if (!canEdit) return;
    setSaving(true);
    setError("");
    const body = { name: (values.name || "").trim() };
    try {
      const saved = isNew
        ? await createSprTemplateNazn(body)
        : await saveSprTemplateNazn(idShb, body);
      message.success("Сохранено");
      onSaved?.(saved);
    } catch (e) {
      setError(e.message || "Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="spr-template-nazn-card__center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="spr-template-nazn-card__tab">
      {error ? (
        <Alert type="error" showIcon message={error} style={{ marginBottom: 12 }} />
      ) : null}
      <Form
        form={form}
        {...formItemLayout}
        onFinish={onFinish}
        requiredMark={false}
        disabled={!canEdit}
      >
        <Form.Item
          label="Наименование"
          name="name"
          rules={[{ required: true, message: "Укажите наименование" }]}
        >
          <Input maxLength={80} autoFocus={isNew || canEdit} />
        </Form.Item>
      </Form>
      <Space className="spr-template-nazn-card__footer">
        {canEdit ? (
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Сохранить
          </Button>
        ) : null}
        <Button onClick={onCancel}>Закрыть</Button>
      </Space>
    </div>
  );
};

export default SprTemplateNaznMain;
